import { DateFieldPopper } from "@mirage/store/entityTableStore";
import { Typography, Link } from "@mui/material";
import { Stack } from "@mui/system";
import { NamedTimeRanges, TimeRangeItem } from "@shared/mirage/entities/NamedTimeRanges";
import { memo } from "react";

export const DateFilterPopperGroup: React.FC<DateFilterPopperGroupProps> = memo(({ title, timeRanges, onClick }) => {
    const additionalSpaceLabels = [NamedTimeRanges.Calendar_Day.Next, NamedTimeRanges.Calendar_Day.Previous];
    return (
        <>
            <Typography>{title}</Typography>
            <Stack alignItems={"flex-start"} paddingBottom={1}>
                {timeRanges?.map((r, idx) => {
                    const additionalSpaceRequired = additionalSpaceLabels.includes(r.caption);
                    const clickableElement = (
                        <Link onClick={() => onClick(r.name)} component="button" variant="body2" underline="hover" key={idx}>
                            {r.caption}
                        </Link>
                    );
                    return additionalSpaceRequired ? (
                        <>
                            <div style={{ paddingBottom: "0.5rem" }}></div>
                            {clickableElement}
                        </>
                    ) : (
                        clickableElement
                    );
                }) || null}
            </Stack>
        </>
    );
});

interface DateFilterPopperGroupProps {
    title: string;
    setDateFilterPopper: React.Dispatch<React.SetStateAction<DateFieldPopper>>;
    timeRanges: TimeRangeItem[];
    onClick: (namedRange: string) => void;
}
